// src/components/StarField.js
import React from 'react';

const StarField = () => {
    const [dots, setDots] = React.useState([]);

  React.useEffect(() => {
    // Generate a grid of dots
    // rowCount / colCount can be tweaked for density
    const rowCount = 30;
    const colCount = 40;
    const dotArray = [];

    for (let row = 0; row < rowCount; row++) {
      for (let col = 0; col < colCount; col++) {
        dotArray.push({
          id: `${row}-${col}`,
          // Position each dot evenly across the screen
          top: (row / (rowCount - 1)) * 100, // from 0% to 100%
          left: (col / (colCount - 1)) * 100,
          delay: Math.random() * 5,       // random animation delay (0-5s)
          duration: 3 + Math.random() * 30 // random duration (2-6s)
        });
      }
    }

    setDots(dotArray);
  }, []);

  return (
    <div className="dot-grid">
      {dots.map((dot) => (
        <div
          key={dot.id}
          className="dot"
          style={{
            top: `${dot.top}%`,
            left: `${dot.left}%`,
            animationDelay: `${dot.delay}s`,
            animationDuration: `${dot.duration}s`
          }}
        />
      ))}
    </div>
  );
};

export default StarField;
